'use strict';

angular.module('amexReconciliationApp')
  .filter('collectionFilter', function() {
    return function (collection, searchTerm, props) {
      if (angular.isUndefined(searchTerm)) {
        return collection;
      }

      var terms = cleanse(searchTerm).split(' ');
      return _.filter(collection, function(item) {
        return _.every(terms, function(term) {
          return isTermMatch(term, item, props);
        });
      });
    };

    function isTermMatch(term, item, props) {
      return matchStringFor(item, props).indexOf(term) > -1;
    }

    function matchStringFor(obj, props) {
      return cleanse(
        _(obj)
          .pick(props)
          .values()
          .value()
          .join(' ')
          .toUpperCase()
      );
    }

    function cleanse(string) {
      return string.replace(/\'/g, '').toUpperCase();
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/collectionFilter.js
// module id = 553
// module chunks = 0